<div
    class="sir-checkbox-container"
    [ngClass]="{
        'is-invalid': (valid$ | async) === false,
    }">
    <input
        type="checkbox"
        [id]="id"
        [name]="name"
        [checked]="checked"
        [attr.data-identifier]="identifier"
        (change)="onChange($event)"
        (blur)="onTouchedCallback()" />
    <div class="sir-checkbox-text">
        @if (validationService?.isRequired(control)) {
            <span class="sir-required-asterisk" aria-hidden="true">*</span>
        }
        <sirius-label [for]="id" textStyle="system" textStyleSize="l">
            <span [outerHTML]="label"></span>
        </sirius-label>
    </div>
</div>
